import ModerationSidebarContainer from './ModerationSidebar.container'

export default ModerationSidebarContainer